import { Mobile, Pc } from '../../hooks/MediaQuery'
import Page5Pc from './Page5Pc'
import Page5Mobile from './Page5Mobile'
import { useEffect, useState } from 'react'
import { selectGoodsList } from '../../api/x_goods'
import { useParams } from 'react-router-dom'

function Page5() {
  const [goods, setGoods] = useState([])
  let { id } = useParams()

  useEffect(() => {
    async function fetchGoods() {
      const response = await selectGoodsList({ useYn: 'Y', caSeq: id })
      const data = response.data.data
      setGoods(data)
    }
    fetchGoods()
  }, [])

  return (
    <>
      <Pc>
        <Page5Pc goods={goods} />
      </Pc>
      <Mobile>
        <Page5Mobile goods={goods} />
      </Mobile>
    </>
  )
}

export default Page5
